module.exports = __webpack_public_path__ + "img/zfb.f9f04ed3.jpeg";